import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import './index.css';
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';
import { thunk } from 'redux-thunk';
import generalReducer from './store/reducers/general';
import clientDataPlatformReducer from './store/reducers/clientDataPlatform';
import reducer from "./store/reducers/keywordExportTool.js"
import bulkUploadToolReducer from './store/reducers/bulkUploadTool';
import contentGenerationToolReducer from './store/reducers/contentGenerationTool';

const composeEnhancers = process.env.NODE_ENV === 'development' ?  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : null || compose;

const rootReducers = combineReducers({
    general: generalReducer,
    accuranker: reducer,
    clientDataPlatform: clientDataPlatformReducer,
    bulkUploadToolReducer: bulkUploadToolReducer,
    contentGenerationTool: contentGenerationToolReducer
});

const store = createStore(rootReducers, composeEnhancers(applyMiddleware(thunk)));

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

const rootElement = document.getElementById('root')
const root = createRoot(rootElement);
root.render(app)

serviceWorker.unregister();
